<template>
  <b-row>
    <b-col cols="12">
      <b-tabs>
        <b-tab title="All Transactions">
          <AllTransaction />
        </b-tab>
        <b-tab title="Deposits" active>
          <Deposit />
        </b-tab>
        <b-tab title="Withdrawals">
          <Withdrawal />
        </b-tab>
        <b-tab title="PayID Clients">
          <PayIDClient />
        </b-tab>
      </b-tabs>
    </b-col>
    <ModalAddTrans />
  </b-row>
</template>

<script>
import { BCol, BRow, BTabs, BTab } from "bootstrap-vue";
import AllTransaction from "./AllTransaction.vue";
import PayIDClient from "./PayIDClient.vue";
import Deposit from "./Deposit.vue";
import Withdrawal from "./Withdrawal/index.vue";
import ModalAddTrans from "../../components/modal/ModalAddTrans.vue";

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    AllTransaction,
    PayIDClient,
    Deposit,
    Withdrawal,
    ModalAddTrans,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
